import React, { FC } from 'react';
import Styles from '@/assets/js/Styles';
import Container from '@/components/Container';
import { Typography, Box } from '@mui/material';
import { ChildrenProp } from '@/declarations/ChildrenProp';
import { formatNumberWithSpaces } from '@/utils/formatNumbersWithSpaces';

interface MediaCounts {
  image?: number;
  audio?: number;
  video?: number;
  document?: number;
}

interface TotalCountMediaObjectsProps {
  title?: string;
  description?: string;
  counts: MediaCounts;
}

export const TotalCountMediaObjects: FC<ChildrenProp & TotalCountMediaObjectsProps> = ({
  children,
  title,
  description,
  counts,
}) => {
  return (
    <Container
      column
      fullWidth
      fullHeight
      sx={{
        p: 4,
        background: `${Styles.Colors.WHITE}`,
        borderRadius: Styles.Dimensions.RADIUS_ROUNDNESS_DEFAULT,
        boxShadow: '1px 2px #ccc',
      }}>
      <Container fullWidth>
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 500 }}>{title}</Typography>
      </Container>
      {description}
      <Box sx={{ mt: 2 }}>
        <Typography>Images: {formatNumberWithSpaces(counts.image)}</Typography>
        <Typography>Audio: {formatNumberWithSpaces(counts.audio)}</Typography>
        <Typography>Video: {formatNumberWithSpaces(counts.video)}</Typography>
        <Typography>Documents: {formatNumberWithSpaces(counts.document)}</Typography>
      </Box>
      {children}
    </Container>
  );
};
